// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__3g8jd","approved":"Status_approved__3AVhe","rejected":"Status_rejected__3APny","expired":"Status_expired__wH2WJ","label":"Status_label__jPW2m"};